export const ALT_ATTRIBUTE_STATIC_MESSAGE = 'Operation commerciale Lucky cart';